<script>
import Layout from '@/Shared/layout/editor'
import Menu from '@/Editor/Menu'
import FieldMenu from '@/Editor/FieldMenu'
import { Link } from '@inertiajs/vue3'

export default {
//   Using a render function...
  layout: (h, page) => h(Layout, [page]),

  data() {
        return {
          menuStatus: false,      
          draggedItem: null,
          menuData: null,
          menuType: null,
          droppedItems: [],
          RenderedItems: [],      
        }
    },
    methods: {
      updateMenuStatus(status, type = null){
        this.menuStatus = status;
        this.menuType = type;
      },
      onDragStart(event, uuid, data) {
      event.dataTransfer.effectAllowed = 'move';
      this.draggedItem = {"uuid":uuid, "data":data}
      },
      onDrop(event, location) {
        if (this.draggedItem) {
          // this.droppedItems.push(this.draggedItem);
          // const index = this.items.indexOf(this.draggedItem);
          // if (index > -1) {
          //   this.items.splice(index, 1);
          // }

          if(JSON.parse(this.draggedItem.data).on_creation.show_fields == "true") {
            // show fields
            this.updateMenuStatus('field-menu', "create")
            this.menuData = this.draggedItem;
          } else {
            //alert("location:"+location+" + uuid:"+this.draggedItem.uuid)
            // this.updateMenuStatus(false)
            this.addComponent(this.draggedItem);
          }
          this.draggedItem = null;

        }
      },
      addComponent(data){

        this.RenderedItems.push(data);
        this.updateMenuStatus(false)

      },
      endEditing(){
        this.updateMenuStatus(false)
      },
      columnsValue(item) {
        let columns = 1; // Default value in case of error or invalid data
        try {
          const data = typeof item.data === 'string' ? JSON.parse(item.data) : item.data;
          columns = data.on_edit.data.columns.value;
        } catch (e) {
          console.error('Error parsing item.data:', e);
        }
        return columns;
      },
      editComponent(item){

        // create edit-field-menu
        this.menuData = item;
        this.updateMenuStatus('field-menu', "edit")

        //alert(item.uuid);
      }
    },

//   Using shorthand syntax...
  layout: Layout,
}
</script>

<script setup>
defineProps({ user: Object, pages: Object, sites: Object, categories: Object})
</script>

<template>

<div class="w-full h-16" style="background:rgb(247, 247, 247);"></div>


<template v-if="RenderedItems.length === 0">
  <div class="flex items-center justify-center w-full h-full flex-col text-center" style="margin-top: -8rem; margin-bottom: -8rem;" @dragover.prevent @drop="onDrop($event, 0)">
      <h2 class="text-2xl font-semibold pb-2">Empty Page</h2>
      <p>Use the <button class="underline text-main" @click="this.updateMenuStatus('menu')">component Manager</button> to decorate it. {{ this.menuStatus }}</p>
  </div>
</template>
<template v-else>
  <div class="mega-container flex flex-col gap-4">
  <!-- data rendered -->
  <template v-for="item in RenderedItems">
    <!-- {{ JSON.parse(item.data).on_edit.data }} -->



      <div class="flex gap-4">

          <template v-for="n in columnsValue(item)" :key="n">

          <div class="h-32 bg-bay" :class="'col-'+n" :style="'width:calc(100% / '+columnsValue(item)+');'">
            <button @click="this.editComponent(item)">Edit</button>
          </div>
            
          </template>

      </div>


  </template>
</div>
  <!-- Add new data -->
  <div class="flex items-center justify-center w-full h-full flex-col text-center" style="margin-top: -8rem; margin-bottom: -8rem;" @dragover.prevent @drop="onDrop($event, 0)">
      <h2 class="text-2xl font-semibold pb-2">Add Component to Page</h2>
      <p>Use the <button class="underline text-main" @click="this.updateMenuStatus('menu')">component Manager</button> to decorate it. {{ this.menuStatus }}</p>
  </div>

</template>



<div class="w-full h-64" style="background:rgb(247, 247, 247);"></div>


<template v-if="this.menuStatus === 'menu'" :key="this.menuStatus">
<Menu :categories="categories" :onDragStart="this.onDragStart"  />
</template>

<template v-if="this.menuStatus === 'field-menu'" :key="this.menuStatus">
<FieldMenu :categories="categories" :endEditing="endEditing" :fields="menuData" :type="menuType" :onDragStart="this.onDragStart" :addComponent="addComponent"  />
</template>

</template>